<div class="title_bg">
  <div class="title_text">
    <h1 class="title">
      ПДД Марафон 2026 — все экзаменационные вопросы подряд
    </h1>
    <div class="title_mobile">
      ПДД Марафон 2026
    </div>
  </div>
  <div class="settings_bg">
    <button class="settings" (click)="SettingsService.set_open_settings(true)">
      <i class="icon"></i>
    </button>
  </div>
</div>
<ng-container *ngIf="BilletsService.billets_question.length == BilletsService.my_answer_marathon.length">
  <div style="padding-top: 20px;">
    <div style="
  padding: 10px;
  display: grid;
  gap: 10px;
  background: #f5f5f7;
  border-radius: 6px;
  border: solid 1px #f5f5f7;
  color: #1d1d1f;">
      <div>
        <b>Результаты марафона</b>
      </div>
      <div>
        <div>
          Правильных ответов: <span style="color: #00cc66;">{{count_success()}}</span>
        </div>
        <div>
          Допущено ошибок: <span style="color: #ff4e43;">{{count_error()}}</span>
        </div>
      </div>

    </div>
  </div>
</ng-container>


<div style="display: grid; gap: 20px;  padding-top: 20px;">
  <div
    [class]="{'billets_list_control':this.scroll_billets.all_billets == false, 'billets_list_control_none_scroll':this.scroll_billets.all_billets == true,}">
    <div style="position: relative; width: 100%; overflow: hidden;">
      <div *ngIf=" this.scroll_billets.scrollLeft > 0 && this.scroll_billets.all_billets == false"
           style="position: absolute; left: 0px; top: 0px; bottom: 0px; display: flex; align-items: center; gap: 10px; background: #fff; background: linear-gradient(90deg,rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);">
        <div (click)="scrollLeft(scrollContainerBillets)"
             style="padding: 5px; background: #1a1a1a; border-radius: 6px; cursor: pointer;">
          <i class="icon_scroll_left"></i>
        </div>
        <div style="width: 10px;"></div>
      </div>

      <div *ngIf="!this.scroll_billets.isEnd  && this.scroll_billets.all_billets == false"
           style="position: absolute; right: 0px; top: 0px; bottom: 0px; display: flex; align-items: center; gap: 10px; background: #fff; background: linear-gradient(90deg,rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%);">
        <div style="width: 10px;"></div>
        <div (click)="scrollRight(scrollContainerBillets)"
             style="padding: 5px; background: #1a1a1a; border-radius: 6px;  cursor: pointer;">
          <i class="icon_scroll_right"></i>
        </div>
      </div>
      <div
        [class]="{'list_billets': this.scroll_billets.all_billets == false,  'none_vue_scroill': this.scroll_billets.all_billets == false, 'list_billets_none_scroll': this.scroll_billets.all_billets == true}"
        #scrollContainerBillets (scroll)="onScroll($event)" (mousedown)="onMouseDown($event, scrollContainerBillets)">
        <ng-container *ngFor="let billet of this.BilletsService.billets_question; let  i = index">
          <div #billet
               [class]="{
               'billet':!billet.marathon?.select,
               'billet_checked': (billet.marathon?.select  && (SettingsService.showResultsOnlyAfterCompletion) && (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length < BilletsService.billets_question.length)) ,
               'billet_success': (billet.marathon?.select && billet.marathon?.status && ((!SettingsService.showResultsOnlyAfterCompletion) || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length))),
               'billet_error': (billet.marathon?.select && !billet.marathon?.status && ((!SettingsService.showResultsOnlyAfterCompletion) || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length))),
               'active': i==this.active_billet}"
               (click)="openBillet(i)">
            {{ i + 1 }}
          </div>
        </ng-container>
      </div>
    </div>
    <div
      style="padding: 5px; background: #1a1a1a; border-radius: 6px; display: flex; justify-content: center; align-items: center;"
      (click)="vueAllBillets()">
      <div
        style="cursor: pointer; display: flex; color: #fff; justify-content: center; align-items: center; gap: 10px;">
        <div *ngIf=" this.scroll_billets.all_billets == true">
          Свернуть спиоско билетов
        </div>
        <div>
          <i
            [class]="{'icon_dispaly_all': this.scroll_billets.all_billets == false, 'icon_dispaly_none_all': this.scroll_billets.all_billets == true}"></i>
        </div>
      </div>
    </div>
  </div>
  <div>
    <ng-container *ngFor="let billet of this.BilletsService.billets_question; let  i = index">
      <ng-container *ngIf="i==this.active_billet">
        <div style="display: grid; gap: 10px;">
          <ng-container *ngIf="billet.question.img">
            <div>
              <img src="{{billet.question.img}}" alt="{{billet.question.text}}" fetchpriority="high">
            </div>
          </ng-container>
          <ng-container *ngIf="!billet.question.img">
            <div>
              <img src="/assets/billets/none_img.png" alt="{{billet.question.text}}" fetchpriority="high">
            </div>
          </ng-container>
          <div class="question">
            <h2>{{ billet.question.text }}</h2>
          </div>
          <div>
            <ul class="answers">
              <ng-container *ngFor="let answer of billet.answers;  let  answer_index = index">
                <li (click)="chekAnswer(i, answer_index)" [class]="{
                'none_select': billet.marathon?.select == true,
                'success':( (answer.marathon_select && answer.correct) || (answer.correct == true && billet.marathon?.select == true)) && ((!SettingsService.showResultsOnlyAfterCompletion) || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length)),
                'error': answer.marathon_select && !answer.correct && ((!SettingsService.showResultsOnlyAfterCompletion) || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length)),
                'anonymous': answer.marathon_select && SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length < BilletsService.billets_question.length
                }">
                  <div class="number">
                    <div>
                      {{ answer_index + 1 }}
                    </div>
                  </div>
                  <div>
                    {{ answer.text }}
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
          <div style="display: grid; gap: 10px;  gap: 10px;">
            <div
              *ngIf="(!SettingsService.showResultsOnlyAfterCompletion) || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length) "
              [class]="{'open_explanation':open_explanation == true, 'close_explanation':open_explanation == false}">
              <ng-container *ngFor="let answer of billet.answers;">
                <ng-container *ngIf="answer.correct  == true">
                  <div
                    style="padding: 10px; background: #fff6e9; border-radius: 6px; border: solid 1px #ffaa33; color: #000;">
                    <div>
                      <h2 style="color: #ffaa33; font-size: 16px;">Объяснение</h2>
                    </div>
                    <div>
                      {{ answer.description }}
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div style="display: flex; gap: 10px;">
              <div style="width: 100%;">
                <button
                  *ngIf="!SettingsService.showResultsOnlyAfterCompletion || (SettingsService.showResultsOnlyAfterCompletion && BilletsService.my_answer_marathon.length == BilletsService.billets_question.length) "
                  class="explanation" (click)="open_explanation = !open_explanation">
                  <div>
                    <ng-container *ngIf="open_explanation == false">
                      Показать подсказу
                    </ng-container>
                    <ng-container *ngIf="open_explanation == true">
                      Скрыть подсказу
                    </ng-container>
                  </div>
                  <div>
                    <i class="icon_element"></i>
                  </div>
                </button>
              </div>
              <div *ngIf="i < this.BilletsService.billets_question.length-1">
                <button class="next_question" (click)="nextQuiz()">
                  <div>
                    Следущий вопрос
                  </div>
                  <div>
                    <i class="icon_next"></i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<settings-component></settings-component>
